var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    attrs: {
      rules: _vm.addRegexToValidationRules,
      tag: "div",
      vid: _vm.id,
      mode: _vm.validationMode,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                class: [
                  { "error-styles": errors[0] },
                  "lf-textfield-container",
                  { "hidden-field": _vm.hidden },
                  { "disabled-field": _vm.disabled },
                ],
              },
              [
                _vm.label
                  ? _c(
                      "div",
                      { staticClass: "label-container" },
                      [
                        _c("div", { staticClass: "label-text" }, [
                          _vm._v(_vm._s(_vm.label)),
                        ]),
                        _vm.requiredField
                          ? _c("span", { staticClass: "required-field" }, [
                              _vm._v("*"),
                            ])
                          : _vm._e(),
                        _vm.showInfo
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "", color: "primary", dark: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  class: [
                                                    _vm.icons.info,
                                                    "label-icon",
                                                  ],
                                                },
                                                "span",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "show-info-message" },
                                  [_vm._v(_vm._s(_vm.showInfo))]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "lf-textfield" }, [
                  _c(
                    "input",
                    _vm._b(
                      {
                        class: [
                          { "error-styles": errors[0] },
                          "lf-textfield-input",
                        ],
                        attrs: {
                          type: _vm.type,
                          disabled: _vm.disabled,
                          placeholder: _vm.placeholder,
                          id: _vm.id,
                          name: _vm.id,
                          autocomplete: _vm.autocompleteType,
                        },
                        domProps: { value: _vm.innerValue },
                        on: {
                          input: _vm.emitValue,
                          blur: _vm.emitValueOnBlur,
                          change: function ($event) {
                            return _vm.handleChange()
                          },
                        },
                      },
                      "input",
                      _vm.props,
                      false
                    )
                  ),
                  _vm.hasValue
                    ? _c("span", {
                        class: [
                          _vm.icons.clearIcon,
                          "clean-icon",
                          "lf-icon__sm",
                        ],
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.clearText.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "messages-container" }, [
                  errors.length
                    ? _c("span", { staticClass: "alert-message" }, [
                        _vm._v(_vm._s(errors[0])),
                      ])
                    : _c("span", {
                        staticClass: "help-message",
                        domProps: { innerHTML: _vm._s(_vm.helpText) },
                      }),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }